import * as React from 'react';

export const FileXLSIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#31C48D"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0982C27.9593 10.2593 26.8672 9.80634 26.0618 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#31C48D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.68076 16.3881C8.68076 15.5444 9.36476 14.8604 10.2085 14.8604H23.9585C24.8023 14.8604 25.4863 15.5444 25.4863 16.3881V28.6104C25.4863 29.4541 24.8023 30.1381 23.9585 30.1381H10.2085C9.36477 30.1381 8.68076 29.4541 8.68076 28.6104V16.3881ZM10.2085 20.9715V24.027H13.2641V20.9715H10.2085ZM14.7919 20.9715V24.027H23.9585V20.9715H14.7919ZM23.9585 19.4437H10.2085V16.3881H23.9585V19.4437ZM23.9585 25.5548H14.7919V28.6104H23.9585V25.5548ZM13.2641 28.6104V25.5548H10.2085V28.6104H13.2641Z"
      fill="#31C48D"
    />
    <rect
      x="6.87561"
      y="33.203"
      width="20.8333"
      height="7.69383"
      rx="1.5625"
      fill="#31C48D"
    />
    <path
      d="M11.4584 39.1848C11.3271 39.1848 11.2144 39.1384 11.1203 39.0455C11.0275 38.9514 10.9811 38.8387 10.9811 38.7075C10.9811 38.5776 11.0275 38.4662 11.1203 38.3734C11.2144 38.2806 11.3271 38.2342 11.4584 38.2342C11.5856 38.2342 11.697 38.2806 11.7924 38.3734C11.8879 38.4662 11.9356 38.5776 11.9356 38.7075C11.9356 38.795 11.9131 38.8752 11.868 38.9481C11.8243 39.0197 11.7666 39.0774 11.695 39.1211C11.6234 39.1635 11.5445 39.1848 11.4584 39.1848Z"
      fill="white"
    />
    <path
      d="M13.4684 35.0603L14.2898 36.4484H14.3216L15.1469 35.0603H16.1193L14.8764 37.0967L16.1471 39.133H15.1568L14.3216 37.743H14.2898L13.4545 39.133H12.4682L13.7429 37.0967L12.492 35.0603H13.4684Z"
      fill="white"
    />
    <path
      d="M16.6782 39.133V35.0603H17.5393V38.4231H19.2853V39.133H16.6782Z"
      fill="white"
    />
    <path
      d="M22.0789 36.2316C22.063 36.0712 21.9947 35.9466 21.8741 35.8578C21.7534 35.7689 21.5897 35.7245 21.3829 35.7245C21.2423 35.7245 21.1237 35.7444 21.0269 35.7842C20.9301 35.8226 20.8559 35.8763 20.8042 35.9453C20.7538 36.0142 20.7286 36.0924 20.7286 36.1799C20.726 36.2528 20.7412 36.3165 20.7744 36.3708C20.8088 36.4252 20.8559 36.4723 20.9156 36.512C20.9752 36.5505 21.0441 36.5843 21.1224 36.6134C21.2006 36.6413 21.2841 36.6652 21.3729 36.685L21.7388 36.7725C21.9165 36.8123 22.0796 36.8653 22.2281 36.9316C22.3765 36.9979 22.5051 37.0794 22.6138 37.1762C22.7226 37.273 22.8067 37.387 22.8664 37.5183C22.9274 37.6495 22.9585 37.8 22.9599 37.9697C22.9585 38.2189 22.8949 38.435 22.769 38.618C22.6443 38.7996 22.464 38.9408 22.2281 39.0416C21.9934 39.141 21.7103 39.1907 21.3789 39.1907C21.0501 39.1907 20.7638 39.1403 20.5198 39.0396C20.2772 38.9388 20.0876 38.7897 19.9511 38.5921C19.8158 38.3933 19.7449 38.1473 19.7383 37.8544H20.5715C20.5808 37.9909 20.6199 38.1049 20.6888 38.1964C20.7591 38.2866 20.8526 38.3548 20.9692 38.4012C21.0872 38.4463 21.2205 38.4688 21.369 38.4688C21.5148 38.4688 21.6414 38.4476 21.7488 38.4052C21.8575 38.3628 21.9417 38.3038 22.0013 38.2282C22.061 38.1527 22.0908 38.0658 22.0908 37.9677C22.0908 37.8762 22.0637 37.7993 22.0093 37.737C21.9563 37.6747 21.8781 37.6217 21.7746 37.5779C21.6726 37.5342 21.5473 37.4944 21.3988 37.4586L20.9553 37.3473C20.612 37.2637 20.3408 37.1331 20.142 36.9555C19.9431 36.7778 19.8443 36.5385 19.8457 36.2376C19.8443 35.991 19.91 35.7756 20.0425 35.5913C20.1764 35.407 20.3601 35.2632 20.5934 35.1598C20.8267 35.0563 21.0919 35.0046 21.3888 35.0046C21.6911 35.0046 21.9549 35.0563 22.1803 35.1598C22.407 35.2632 22.5834 35.407 22.7093 35.5913C22.8352 35.7756 22.9002 35.989 22.9042 36.2316H22.0789Z"
      fill="white"
    />
  </svg>
);

export default FileXLSIcon;
